export interface Language {
    label: string;
    flag: string;
    languageCode: string;
}

export const SELECTED_LANGUAGE_STORAGE_KEY = 'selectedLanguage';

export const supportedLanguages: Language[] = [
    {
        label: 'English',
        flag: 'us',
        languageCode: 'en',
    },
    {
        label: 'Chinese',
        flag: 'cn',
        languageCode: 'zh',
    },
    {
        label: 'French',
        flag: 'fr',
        languageCode: 'fr',
    },
    {
        label: 'Spanish',
        flag: 'es',
        languageCode: 'es',
    },
    {
        label: 'Italian',
        flag: 'it',
        languageCode: 'it',
    },
    {
        label: 'German',
        flag: 'de',
        languageCode: 'de',
    },
];

export const multiLanguageWidgetSupportedLanguages: { label: string; isoCode: string }[] = [
    {
        label: 'Chinese',
        isoCode: 'zh',
    },
    {
        label: 'Dutch',
        isoCode: 'nl',
    },
    {
        label: 'English',
        isoCode: 'en',
    },
    {
        label: 'French',
        isoCode: 'fr',
    },
    {
        label: 'German',
        isoCode: 'de',
    },
    {
        label: 'Italian',
        isoCode: 'it',
    },
    {
        label: 'Japanese',
        isoCode: 'ja',
    },
    {
        label: 'Korean',
        isoCode: 'ko',
    },
    {
        label: 'Arabic',
        isoCode: 'ar',
    },
    {
        label: 'Portuguese',
        isoCode: 'pt',
    },
    {
        label: 'Russian',
        isoCode: 'ru',
    },
    {
        label: 'Spanish',
        isoCode: 'es',
    },
];
